module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-5a2b2767.png";